import { Nav } from "../components/site/Nav";
import { Hero } from "../components/site/Hero";
import { Ribbon } from "../components/site/Ribbon";
import { Services } from "../components/site/Services";
import { Manifesto } from "../components/site/Manifesto";
import { Trust } from "../components/site/Trust";
import { Pricing } from "../components/site/Pricing";
import { LocalAreas } from "../components/site/LocalAreas";
import { Testimonials } from "../components/site/Testimonials";
import { BookingForm } from "../components/site/BookingForm";
import { Footer } from "../components/site/Footer";

export default function Landing() {
  return (
    <div className="bg-[#F9F8F6] min-h-screen">
      <Nav />
      <main>
        <Hero />
        <Ribbon />
        <Services />
        <Manifesto />
        <Trust />
        <Pricing />
        <LocalAreas />
        <Testimonials />
        <BookingForm />
      </main>
      <Footer />
    </div>
  );
}
